import { Component, inject, OnChanges, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import { ModelService } from '../../../services/model-service';
import { ConfigurationSection, UserStateService } from '../../../services/user-state.service';
import { GuruEntity } from '../../../model/guru-entity';
import { SelectionUtils } from '../../selection-utils';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-enviro-kit-site-survey',
  imports: [MatIcon, FormsModule],
  templateUrl: './enviro-kit-site-survey.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './enviro-kit-site-survey.component.css'
})
export class EnviroKitSiteSurveyComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);
  private imagePrefix = 'assets/configurator/EnviroKit/';
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  returnAirPanelHeightSelection!: GuruEntity;
  returnAirPanelWidthSelection!: GuruEntity;
  returnAirPanelAboveFloorSelection!: GuruEntity;
  returnAirOpeningHeightSelection!: GuruEntity;
  returnAirOpeningWidthSelection!: GuruEntity;
  returnAirOpeningAboveFloorSelection!: GuruEntity;
  cabinetDepthInsideSelection!: GuruEntity;
  cabinetWidthInsideSelection!: GuruEntity;
  fanDeckToTopCoilSupportSelection!: GuruEntity;
  topOfDrainPanToBaseSelection!: GuruEntity;
  fanDeckToPipingSelection!: GuruEntity;
  pipingElevationSelection!: GuruEntity;
  blowerHeightSelection!: GuruEntity;
  blowerWidthSelection!: GuruEntity;
  replacementSelection!: GuruEntity
  oeMotorSelection!: GuruEntity;
  oeControlsSelection!: GuruEntity;
  readonly handArrangementImagePath = signal<string>(undefined!);
  isExpanded = true;
  private sectionKey = ConfigurationSection.SITE_SURVEY;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.returnAirPanelHeightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAPanelHeight');
    this.returnAirPanelWidthSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAPanelWidth');
    this.returnAirPanelAboveFloorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAPanel2Floor');
    this.returnAirOpeningHeightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAFlangeHeight');
    this.returnAirOpeningWidthSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAFlangeWidth');
    this.returnAirOpeningAboveFloorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAFlange2Floor');
    this.cabinetDepthInsideSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetDepth');
    this.cabinetWidthInsideSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetWidth');
    this.fanDeckToTopCoilSupportSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRetAirBlockHeight');
    this.topOfDrainPanToBaseSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainPanHeight');
    this.fanDeckToPipingSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBlowerDeck2Piping');
    this.pipingElevationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPipingHeight');
    this.blowerHeightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBlowerHeight');
    this.blowerWidthSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBlowerWidth');
    this.replacementSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USReplacement');
    this.oeMotorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOEMotorType');
    this.oeControlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOEControlType');
    this.modelService.executeHierarchy(this.engineKey(), 'hierDOC').subscribe(() => {
      this.modelService.getCharacteristicValue(this.engineKey(), 'UnitHandArrangementImage', 'FileName').subscribe(result => {
        this.handArrangementImagePath.set(this.imagePrefix + result);
      });
    });
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
    entity.Value = newValue;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
